import styled from 'styled-components';

export const ContainerHeaderGrid = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left:  16px;
  padding-right: 16px;
  background-color: ${props => props.theme.white};
  border-bottom: 1px solid ${props => props.theme.icon};
`;

export const TitleType = styled.span`
  margin: 0;
  font-size: 13px;
  word-break: break-all;
`;

export const AreaButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  gap: 8px;
`;

export const GridContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid ${props => props.theme.icon};
  border-radius: 4px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
`;

export const Spinner = styled.div`
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-left-color: ${props => props.theme.pantone2726C};
  border-radius: 50%;
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
  margin: 0 10px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const TitleGrid = styled.div`
  font-weight: bold;
  color: ${props => props.theme.pantoneBlack};
  margin-bottom: 8px;
`;

export const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px;
  color: ${props => props.theme.icon};
`;

export const ContainerScroll = styled.div`
  max-height: 400px;
  overflow-y: auto;
`;